module.exports = __webpack_public_path__ + "static/media/culture.c36ca527.webp";